import controller from './button.controller'
import template from './button.html'

const ButtonComponent = {
	bindings: {
		text: '@',
		btnClass: '@',
		btnStartIcon: '@',
		btnEndIcon: '@',
		onClick: '&'
	},
	controller,
	template,
};

export default ButtonComponent;



// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/common/button/button.component.js